<template>
  <div class="remove-member">
    <div class="remove-member-warp">
      <account-select-wrapper ref="removeSelectWrapper" :contacts="imTeamMemberCheckList" type="remove" @operate="operate" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AccountSelectWrapper from '../AccountSelectWrapper'
export default {
  name: 'TeamMemberRemove',
  components: {
    AccountSelectWrapper
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      imTeamMemberCheckList: state => state.imTeamMemberCheckList,
      imActiveAccount: state => state.imActiveAccount
    })
  },
  watch: {
  },
  methods: {
    ...mapActions(['removeTeamMembers']),
    operate (checkList) {
      const accounts = checkList.map(item => item.im_accid)
      this.removeTeamMembers({ teamId: this.imActiveAccount.to, accounts: accounts })
      this.$refs.removeSelectWrapper.clearData()
    }
  }
}
</script>

<style lang="stylus" scoped>
.remove-member {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.remove-member-warp {
  flex-grow: 1;
  max-height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/member/TeamMemberRemove.vue